import React, { Component } from 'react'
import { Button, Form, Modal, Popconfirm, Input, Icon, message, Upload, Divider, Table } from 'antd'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions as agreementActions } from '../../../redux/modules/jobFunctions/jobAgreementActions'
import Loader from '../../common/Loader'
import styled from 'styled-components'
import _ from 'lodash'
import moment from 'moment'

const FormItem = Form.Item
const { TextArea } = Input
const propTypes = {}
const StyledActionContainer = styled.div`
  display: flex;
`

const StyledGoParentFolder = styled.div`
  background-color: #d9283b !important;
`

const CreatePathForm = Form.create()(
  class extends React.Component {
    render() {
      const {
        handleFolderCreate,
        handleFolderCancel,
        folderName,
        modalFolderVisible,
        folderId,
        form
      } = this.props
      const { getFieldDecorator } = form
      return (
        <Modal
          visible={modalFolderVisible}
          title="Add Folder"
          okText={folderId ? 'Save Changes' : 'Create'}
          onCancel={handleFolderCancel}
          onOk={handleFolderCreate}
          maskClosable={false}
        >
          <Form layout="vertical">
            <FormItem label="Folder Name">
              {getFieldDecorator('name', {
                rules: [
                  {
                    required: true,
                    message: 'Folder name cannot be blank.'
                  }
                ],
                initialValue: folderId ? folderName : ''
              })(
                <Input
                  placeholder="Type the folder name..."
                  initialvalue={folderId ? folderName : ''}
                />
              )}
            </FormItem>
          </Form>
        </Modal>
      )
    }
  }
)

class JobAgreements extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      fileList: [],
      uploading: false,
      contentFolder: null,
      content: null,
      treeData: null,
      showDocumentActions: false,
      showFolderActions: false,
      currentFolderId: null
    }
  }

  componentWillMount() {
    this.props.jobAgreementRefresh({
      jobId: this.props.jobId,
      folderId: this.state.currentFolderId
    })
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null,
      activeKey: '1'
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const { fileList } = this.state
      const formData = new FormData()
      fileList.forEach(file => {
        formData.append('file', file)
      })
      formData.append('type', 'agreement')
      formData.append('updated_by_id', this.props.user.userId)
      formData.append('job_id', this.props.jobId)
      formData.append('name', values.name)
      formData.append('description', values.description)

      if (this.state.currentFolderId) {
        formData.append('folder_id', this.state.currentFolderId)
      }

      this.setState({
        uploading: true
      })

      values.job_id = this.props.jobId

      if (this.state.currentId === 0) {
        formData.append('created_by_id', this.props.user.userId)
        this.props.createAgreement({
          jobId: this.props.jobId,
          formData: formData,
          folderId: this.state.currentFolderId
        })
        message.success('Agreement created.')
      } else {
        formData.append('agreementId', this.state.currentId)
        this.props.updateAgreement({
          jobId: this.props.jobId,
          formData: formData,
          agreementId: this.state.currentId,
          folderId: this.state.currentFolderId
        })
        message.success('Changes saved.')
      }

      form.resetFields()
      this.setState({ contentData: null, currentId: 0, modalVisible: false, fileList: [] })
    })
  }

  handleDeleteAgreement = event => {
    const form = this.props.form

    this.props.deleteAgreement({
      jobId: this.props.jobId,
      agreementId: this.state.currentId,
      folderId: this.state.currentFolderId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false,
      activeKey: '1'
    })
  }

  handleDelete = (type, id, record) => {
    const form = this.props.form
    if (type === 'file') {
      this.props.deleteAgreement({
        jobId: this.props.jobId,
        agreementId: id,
        folderId: this.state.currentFolderId
      })

      form.resetFields()
      message.success('Record deleted.')
      this.setState({
        contentData: null,
        currentId: 0,
        modalVisible: false,
        activeKey: '1'
      })
    } else {
      this.props.deleteFolder({
        folderId: id,
        jobId: this.props.jobId,
        currentFolderId: record.parent_id
      })
      message.success('folder deleted!')
      this.setState({
        modalFolderVisible: false,
        pathEditId: null,
        showFolderActions: false,
        selectedFolder: null
      })
    }
  }

  handleEdit = (type, id, content, row) => {
    if (type === 'file') {
      this.setState({
        modalVisible: true,
        currentId: id,
        contentData: row,
        activeKey: '1'
      })
    } else {
      this.pathFormRef.props.form.resetFields()
      this.setState({
        modalFolderVisible: true,
        folderId: id,
        folderName: content
      })
    }
  }

  handleAddFolderButton = () => {
    this.pathFormRef.props.form.resetFields()
    this.setState({
      modalFolderVisible: true
    })
  }

  savePathFormRef = pathFormRef => {
    this.pathFormRef = pathFormRef
  }

  handleFolderCreate = () => {
    const form = this.pathFormRef.props.form

    form.validateFields((err, values) => {
      if (err) {
        return
      }

      if (this.state.folderId) {
        this.props.updateFolder({
          name: values.name,
          jobId: this.props.jobId,
          folderId: this.state.folderId,
          currentFolderId: this.state.currentFolderId
        })
      } else {
        this.props.createFolder({
          parentId: this.state.currentFolderId,
          jobId: this.props.jobId,
          name: values.name,
          folderId: this.state.currentFolderId
        })
      }

      message.success('Path created!')
    })

    this.pathFormRef.props.form.resetFields()
    this.setState({
      modalFolderVisible: false,
      pathEditId: null,
      selectedFolder: null
    })
  }

  handleFolderCancel = () => {
    this.pathFormRef.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalFolderVisible: false })
  }

  getTableColumns = () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: item => {
          if (item['type'] === 'folder') {
            return (
              <a
                href="javascript:;"
                onClick={() =>
                  this.onClickLineItem(
                    null,
                    item['type'],
                    item['name'],
                    item['id'],
                    item['parentId'],
                    item['parentName']
                  )
                }
              >
                <Icon type="folder" theme="filled" /> {item['name']}
              </a>
            )
          } else {
            const url = _.get(item, 'row.attachment.signedUrl', '#')
            return (
              <a href={url} target="_blank">
                <Icon type="file" theme="filled" /> {item['name']}
              </a>
            )
          }
        }
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description'
      },
      {
        title: 'Created By',
        key: 'created_by',
        dataIndex: 'created_by'
      },
      {
        title: 'Created Date',
        key: 'created_date',
        dataIndex: 'created_date'
      },
      {
        title: 'Updated By',
        key: 'updated_by',
        dataIndex: 'updated_by'
      },
      {
        title: 'Updated Date',
        key: 'updated_date',
        dataIndex: 'updated_date'
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => {
          const description =
            record.name['type'] === 'file' ? record.description : record.name['name']
          return (
            <span>
              <Icon
                type="edit"
                onClick={() =>
                  this.handleEdit(
                    record.name['type'],
                    record.name['id'],
                    description,
                    record.name['row']
                  )
                }
                theme="filled"
              />
              <Divider type="vertical" />
              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={() =>
                  this.handleDelete(record.name['type'], record.name['id'], record.name['row'])
                }
                okText="Yes"
                cancelText="No"
              >
                <Icon type="delete" theme="filled" />
              </Popconfirm>
            </span>
          )
        }
      }
    ]
  }

  getTableData = () => {
    const documentsAndFolders = _.get(this.props, 'agreementActions.agreements.data')

    let data = []

    if (documentsAndFolders) {
      for (const item of documentsAndFolders) {
        let nameParam = []
        nameParam['type'] = item.type
        nameParam['name'] = item.name
        nameParam['id'] = item.id
        nameParam['parentId'] = item.parent_id
        nameParam['parentName'] = item.parent_name
        nameParam['row'] = item
        const itemObj = {
          name: nameParam,
          description: item.description,
          created_by: `${item.created_by_first_name} ${item.created_by_last_name}`,
          updated_by: `${item.updated_by_first_name} ${item.updated_by_last_name}`,
          added_by: `${item.first_name} ${item.last_name}`,
          created_date: moment(item.created_date).format('M/D/YYYY'),
          updated_date: moment(item.updated_date).format('M/D/YYYY')
        }
        data.push(itemObj)
      }
    }

    return data
  }

  onClickLineItem = (row, type, name, id, parentId, parentName) => {
    if (type === 'folder') {
      this.setState({
        currentFolderId: id,
        currentFolderName: name,
        parentFolderId: parentId,
        parentFolderName: parentName
      })

      this.props.jobAgreementRefresh({
        jobId: this.props.jobId,
        folderId: id || parentId
      })
    } else {
      this.setState({
        modalVisible: true,
        currentId: id,
        contentData: row,
        activeKey: '1'
      })
    }
  }

  render() {
    const { contentData } = this.state

    const propsUpload = {
      name: 'file',
      multiple: false,
      action: '//jsonplaceholder.typicode.com/posts/',
      onRemove: file => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file)
          const newFileList = fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList
          }
        })
      },
      beforeUpload: file => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file]
        }))
        return false
      },
      fileList: this.state.fileList
    }

    const { getFieldDecorator } = this.props.form
    if (this.props.agreementActions && !this.props.agreementActions.agreements) {
      return <Loader />
    }

    return (
      <div>
        <CreatePathForm
          wrappedComponentRef={this.savePathFormRef}
          folderName={this.state.folderName}
          handleFolderCreate={this.handleFolderCreate}
          handleFolderCancel={this.handleFolderCancel}
          confirmFolderDelete={this.confirmFolderDelete}
          cancelFolderDelete={this.cancelFolderDelete}
          folderId={this.state.folderId}
          modalFolderVisible={this.state.modalFolderVisible}
        />
        <Modal
          visible={this.state.modalVisible}
          title="Agreement"
          okText={
            this.props.agreementActions && this.props.agreementActions.agreements
              ? 'Save Changes'
              : 'Create'
          }
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          maskClosable={false}
        >
          <Form layout="vertical">
            <div className="row">
              <div className="col-md-12">
                <FormItem label="Name">
                  {getFieldDecorator('name', {
                    rules: [
                      {
                        required: true,
                        message: 'There must be a name'
                      }
                    ],
                    initialValue: contentData ? contentData.name : ''
                  })(<Input />)}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <FormItem label="Description">
                  {getFieldDecorator('description', {
                    initialValue: contentData ? contentData.description : ''
                  })(<TextArea placeholder="Type in your description..." rows={4} />)}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div>Agreement File</div>
                <br />
                <Upload
                  {...propsUpload}
                  customRequest={this.handleUploadAgreementAttachment}
                  name="file"
                >
                  <Button>
                    <Icon type="upload" /> Select the file
                  </Button>
                </Upload>
              </div>
            </div>
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.handleDeleteAgreement}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          Agreement
          <StyledActionContainer>
            {this.state.currentFolderName && (
              <StyledGoParentFolder className="jobsBarAdd">
                <div
                  onClick={() =>
                    this.onClickLineItem(
                      null,
                      'folder',
                      this.state.parentFolderName,
                      this.state.parentFolderId,
                      null
                    )
                  }
                  className="addJobLabel"
                >
                  <Icon type="arrow-up" /> {this.state.currentFolderName}
                </div>
              </StyledGoParentFolder>
            )}

            <div className="jobsBarAdd">
              <i className="fa fa-file" aria-hidden="true" />
              &nbsp;
              <div onClick={() => this.handleAddButton()} className="addJobLabel">
                ADD Agreement
              </div>
            </div>
            <div className="jobsBarAdd">
              <i className="fa fa-folder" aria-hidden="true" />
              &nbsp;
              <div onClick={() => this.handleAddFolderButton()} className="addJobLabel">
                ADD Folder
              </div>
            </div>
          </StyledActionContainer>
        </div>
        {this.props.agreementActions &&
          this.props.agreementActions.agreements && (
            <Table
              pagination={false}
              dataSource={this.getTableData()}
              columns={this.getTableColumns()}
            />
          )}
      </div>
    )
  }
}

const mapStateToProps = ({ agreementActions }, ownProps) => ({
  agreementActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, agreementActions), dispatch)
})

JobAgreements.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobAgreements))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobAgreements.js